import React, {Component, useCallback, useEffect, useState} from 'react';
import theme from '../utils/styling/defaultTheme';

const breakpoints = theme.flexboxgrid.breakpoints;

export const BreakpointContext = React.createContext({
  currentBreakpoint: 'xs',
  //currentWidth: 0,
  screenFrom: () => false,
  screenTo: () => true
});

export const BreakpointProvider = ({children}) => {
  const [currentBreakpoint, setCurrentBreakpoint] = useState('xs');

  // const {state, setState} = useState({
  //   currentBreakpoint: 'xs',
  //   currentWidth: 0
  // });

  const onResize = useCallback(() => {
    const width = Math.floor(window.innerWidth / 16);
    const newCurrentBreakpoint = Object.keys(breakpoints).reduce((acc, key) => {
      return width >= breakpoints[key] ? key : acc;
    });
    setCurrentBreakpoint(newCurrentBreakpoint);
  }, [currentBreakpoint]);

  const screenFrom = useCallback((breakpoint) => {
    const targetBreakpointIdx = Object.keys(breakpoints).indexOf(breakpoint);
    const currentBreakpointIdx = Object.keys(breakpoints).indexOf(currentBreakpoint);
    return currentBreakpointIdx >= targetBreakpointIdx;
  }, [currentBreakpoint]);

  const screenTo = useCallback((breakpoint) => {
    const targetBreakpointIdx = Object.keys(breakpoints).indexOf(breakpoint);
    const currentBreakpointIdx = Object.keys(breakpoints).indexOf(currentBreakpoint);
    return currentBreakpointIdx <= targetBreakpointIdx;
  }, [currentBreakpoint]);

  // on mount effect
  useEffect(() => {
    onResize();
    window.addEventListener('resize', onResize);

    // clean up on unmount
    return () => {
      window.removeEventListener('resize', onResize);
    };
  });

  return (
      <BreakpointContext.Provider value={{
        currentBreakpoint: currentBreakpoint,
        //currentWidth: state.currentWidth,
        screenFrom: screenFrom,
        screenTo: screenTo
      }}>
        {children}
      </BreakpointContext.Provider>
  );
};
